define('modules/templates/views/modal_preview',['require','exports','module','common/views/modal_view','env','ldsh!../templates/modal_preview'],function(require, exports, module){
  "use strict";
  var ModalView = require("common/views/modal_view"),
      config = require("env");

  module.exports = ModalView.extend({
    template: require("ldsh!../templates/modal_preview"),
    triggers: {
      "click .js-select": "template:select"
    },
    helpers: function(){
      var previewUrl = this.model.get("previewUrl");
      if(previewUrl){
        previewUrl = config.apiHost + "/img/assets/" + previewUrl;
      }
      else {
        previewUrl = "/app/img/prev-template.png";
      }
      return {
        previewUrl: previewUrl
      };
    }
  });
});
